function SvgArrowRight() {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43164 6.93921C7.67773 6.69312 7.67773 6.28296 7.43164 6.03687L2.12695 0.704834C1.85352 0.45874 1.44336 0.45874 1.19727 0.704834L0.568359 1.33374C0.322266 1.57983 0.322266 1.98999 0.568359 2.26343L4.7793 6.47437L0.568359 10.7126C0.322266 10.9861 0.322266 11.3962 0.568359 11.6423L1.19727 12.2712C1.44336 12.5173 1.85352 12.5173 2.12695 12.2712L7.43164 6.93921Z"
        fill="black"
      />
    </svg>
  )
}

export default SvgArrowRight
